import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, { useRef, useState, useEffect } from "react";
import { FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";
import Slider from "react-slick";
import * as Styles from "./HealthAnalyseSlider.styles";

export default function HealthAnalyseSlider({
  advantagesList,
  noBorder = false,
  title = "Deine Vorteile",
}) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentDesktopSlide, setCurrentDesktopSlide] = useState(0); // Add state for desktop slide index
  const desktopSliderRef = useRef(null);
  const sliderRef = useRef(null);

  const mobileSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  // Custom arrow components using Feather icons
  function CustomPrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className="custom-prev-arrow"
        style={{
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 9999,
          cursor: "pointer",
          color: "#A0C3DD",
          fontSize: "32px",
        }}
        onClick={onClick}
      >
        <FiArrowLeftCircle />
      </div>
    );
  }

  function CustomNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className="custom-next-arrow"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 9999,
          cursor: "pointer",
          color: "#2ECF96",
          fontSize: "32px",
        }}
        onClick={onClick}
      >
        <FiArrowRightCircle />
      </div>
    );
  }

  // Add CSS to override Slick's default styles
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
          .slick-prev, .slick-next {
            display: none !important;
          }
          .custom-prev-arrow, .custom-next-arrow {
            display: block !important;
          }
        `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const desktopSettings = {
    ...mobileSettings,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    beforeChange: (oldIndex, newIndex) => setCurrentDesktopSlide(newIndex),
    // Add these settings to prevent overflow
    centerMode: false,
    centerPadding: "0px",
    adaptiveHeight: true,
    variableWidth: false,
    maxWidth: "800px",
    // Enable arrows and use custom components
    arrows: false, // Disable built-in arrows
    // Remove custom arrow props as we'll handle them outside the slider
  };
  const goToSlide = (index) => {
    sliderRef.current.slickGoTo(index);
  };

  // Add function to navigate desktop slider
  const goToDesktopSlide = (index) => {
    desktopSliderRef.current.slickGoTo(index);
  };

  return (
    <>
      <Styles.DesktopView className="desktop-only">
        {/* <Styles.BenefitsTitle>{title}</Styles.BenefitsTitle> */}
        {advantagesList.length > 0 ? (
          <div
            style={{
              width: "100%",
              position: "relative",
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            {/* Add custom arrows outside the slider component */}
            <CustomPrevArrow
              onClick={() => desktopSliderRef.current.slickPrev()}
            />
            <CustomNextArrow
              onClick={() => desktopSliderRef.current.slickNext()}
            />

            {/* Completely restructure the slider to fix overflow issues */}
            <div
              style={{
                width: "100%",
                margin: "0 auto",
                boxSizing: "border-box",
              }}
            >
              <Slider
                ref={desktopSliderRef}
                {...desktopSettings}
                className="desktop-advantages-slider"
              >
                {advantagesList.map((advantage) => (
                  <div key={advantage.id} className="slide-item-wrapper">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        padding: "20px 70px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          border: "1px solid #d0d5dd",
                          borderRadius: "12px",
                          padding: "10px",
                        }}
                      >
                        <Styles.Circle style={{ flexShrink: 0 }}>
                          <p>{advantage.id}</p>
                        </Styles.Circle>
                        <div
                          style={{
                            marginLeft: "15px",
                            width: "calc(100% - 50px)",
                            overflow: "hidden",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              lineHeight: "1.5",
                              margin: 0,
                            }}
                          >
                            {advantage.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <Styles.PaginationDots>
              {advantagesList.map((_, index) => (
                <Styles.Dot
                  key={index}
                  active={index === currentDesktopSlide}
                  onClick={() => goToDesktopSlide(index)}
                />
              ))}
            </Styles.PaginationDots>
          </div>
        ) : (
          <p>Vorteile werden geladen...</p>
        )}
      </Styles.DesktopView>
    </>
  );
}
